 angular.module('qkr').controller('errorUploadLookupBeneficiaryController',
                                                ErrorUploadLookupBeneficiaryController);

    ErrorUploadLookupBeneficiaryController.$inject = ['$uibModalInstance', 'data'];

    function ErrorUploadLookupBeneficiaryController($uibModalInstance, data) {
        const vm = this;
        vm.errorRecords = [];

        vm.cancel = () => {
            $uibModalInstance.dismiss('cancel');
        };

        vm.init = () => {
            const errorData = data.split(':')[1];
            if (errorData.indexOf(',') !==-1) {
                vm.errorRecords = _.compact(errorData.replace('[', '').replace(']', '').split(',').slice(0));
            } else {
                vm.errorRecords.push(errorData);
            }

        };
        vm.init();
    }



// WEBPACK FOOTER //
// ./src/controllers/error.uploadlookupBeneficiary.controller.js